import React from 'react';
import styled from 'styled-components';
import Steps from '../Steps';
import OtherConfig from './OtherConfig';

export default function Advance() {
  return (
    <Root>
      <Steps />
      <Vl />
      <OtherConfig />
    </Root>
  );
}

const Root = styled.div`
  display: flex;
`;

const Vl = styled.div`
  background: #e7e7e7;
  width: 1px;
`;
